// Path: libs/core/http/src/lib/utils/build-params.ts
import { HttpParams } from '@angular/common/http';

type Primitive = string | number | boolean | null | undefined;

export function buildParams<T extends Record<string, Primitive | Primitive[]>>(
  query: T
): HttpParams {
  let params = new HttpParams();

  Object.entries(query ?? {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item === null || item === undefined || item === '') {
          return;
        }

        params = params.append(key, String(item));
      });

      return;
    }

    params = params.set(key, String(value));
  });

  return params;
}